<template>
  <a-layout class='s_bf'>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='data'>
        <template v-slot:code="{ index }">
          <div class="width-80 height-80" :id="'qrcode'+index"></div>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="primary" @click='select(record)' :ghost="!record.select" >{{!record.select ?
            "选择":"已选择"}}</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import {getWebUrl} from "@/api/public";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  import { qrcanvas } from 'qrcanvas';
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
  };
  export default {
    name: "webUrl",
    props: {
      url: {
        type: String
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 1,
      });
      let columns = [
        {
          title: "功能页面",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "二维码",
          dataIndex: "code",
          key: "code",
          slots: { customRender: "code" },
        },
        {
          title: "链接地址",
          dataIndex: "url",
          key: "url"
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getWebUrl({...search.value}).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          state.total= res.data.total;
          data.value = res.data.data;
          data.value.forEach((i,k) => {
            if (i.url == props.url) {
              i.select = true
            }else{
              i.select = false
            }
            console.log(k)
            setTimeout(()=>{
              var canvas = qrcanvas({
                data: i.url ,
                size:80,
              })
              document.getElementById('qrcode'+k).innerHTML = '';
              document.getElementById('qrcode'+k).appendChild(canvas);
            },500)
          })
        } else {
          message.error(res.msg);
        }
      };
      //单选
      const select = (e) => {
        e.select = !e.select
        emit("select", e);
      }
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select
      };
    },
  };
</script>